import { render } from "./Unit.vue?vue&type=template&id=40218e84&scoped=true"
import script from "./Unit.vue?vue&type=script&lang=js"
export * from "./Unit.vue?vue&type=script&lang=js"

import "./Unit.vue?vue&type=style&index=0&id=40218e84&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40218e84"]])

export default __exports__